export default __webpack_public_path__ + "static/media/item-menu.a3ab968f.svg";